import React, { Component } from 'react';
import { registerAllModules } from "handsontable/registry";
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import ApiURL from "../../../api/ApiURL";
import axios from "axios";
import cogoToast from 'cogo-toast';
import PageTitle from '../../home/PageTitle';
import LocalStorageHelper from '../../../LocalStorageHelper/LocalStorageHelper';
import TableComponent from '../../common/TableComponent';

class SpotBooking extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        //register Handsontable's modules
        registerAllModules();
        this.state = {
            showModal: false,
            UserId: 0,
            UserRole: "",
            finYearId: 0,
            RedirectToLogin: false,
            columns: [],
            spotPayData: [],
            tcData: [],
            locationData: [],
            vendorCategoryData: [],
            vendorData: [],
            bookingTypeData: [],
            states: [],
            placeOfSupplies: [],
            //---------For Header----------
            bookingId: 0,
            bookingNo: '',
            bookingDate: '',
            firstName: '',
            lastName: '',
            mobile: '',
            email: '',
            stateId: '',
            address: '',
            tripCategory: '',
            travelDestination: '',
            totalPayableAmount: 0,
            totalPaidAmount: 0,
            totalDueAmount: 0,
            bookingStatus: 'Active',

            //---For New entry---
            spotBookingId: 0,
            spotBookingType: '',
            travelCircuitId: '0',
            TravelCircuitName: '',
            locationId: '0',
            LocationName: '',
            vendorCategoryId: '',
            vendorId: '0',
            VendorName: '',
            paymentDate: '',
            spotAmount: 0,
            comment: '',
            spotBookingStatus: 'Pending'
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var _self = this;
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                UserId: userData.UserId,
                UserRole: userData.RoleName
            })
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
        this.getAllDataColumns();
        this.getBookingData();
        this.getAllStateData();
        this.getAllTCData();
    }

    getBookingData = () => {
        var self = this;
        console.log(self.props.bookingId);
        axios.get(ApiURL.GetBookingById(self.props.bookingId))
            .then(response => {
                let respData = response.data;
                console.log(respData.DataResult);
                if (respData.StatusCode === 200) {
                    self.setState({
                        bookingData: respData.DataResult
                    }, () => self.loadBookingData())
                }
            }).catch(error => {
                cogoToast.error("Request Failed! Please Try Again.", { position: 'bottom-center' })
            });
    }
    //Get Booking Data
    loadBookingData = () => {
        var self = this;
        var bkData = self.state.bookingData;
        console.log('bkData:', bkData);
        if (bkData != null) {
            self.setState({
                bookingId: bkData.BookingId,
                bookingNo: bkData.BookingNo,
                bookingDate: bkData.BookingDate,
                firstName: bkData.FirstName,
                lastName: bkData.LastName,
                customerName: bkData.CustomerName,
                mobile: bkData.Mobile,
                email: bkData.Email,
                stateId: bkData.StateId,
                placeOfSupplyId: bkData.PlaceOfSupplyId,
                address: bkData.Address,
                tripCategory: bkData.TripCategory,
                specialistId: bkData.SpecialistId,
                gstin: bkData.GSTIN,
                pan: bkData.PAN,
                tcId: bkData.TravelCircuitId,
                travelCircuitId: bkData.TravelCircuitId,
                travelDestination: bkData.TravelDestination,
                totalPayableAmount: parseFloat(bkData.PayableAmount),
                totalPaidAmount: bkData.PaidAmount,
                totalDueAmount: bkData.DueAmount,
                bookingStatus: bkData.BookingStatus,

            })
        }
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columns: [
                {
                    Header: "Action",
                    accessor: "select",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div
                            className="text-center"
                            title="Select"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleEdit(row.original)}
                        >
                            <i className="fa-solid fa-pen-to-square"></i>
                        </div>
                    ),
                },
                {
                    Header: "Payment Date",
                    accessor: "PaymentDate",
                    className: "text-center",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value}
                            {/* {value ? moment(value).format('DD-MM-YYYY') : ""} */}
                        </div>
                    ),
                },
                { Header: "Vendor Type", accessor: "SpotBookingType", className: "text-left", disableFilters: true },
                { Header: "Travel Circuit", accessor: "TravelCircuitName", className: "text-left", disableFilters: true },
                { Header: "Location", accessor: "LocationName", className: "text-left", disableFilters: true },
                { Header: "Vendor", accessor: "VendorName", className: "text-left", disableFilters: true },
                {
                    Header: "Paid Amount",
                    accessor: "PaidAmount",
                    className: "text-right",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
            ],
        })
    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        ...this.state,
                        tcData: dataResult,
                        searchTCData: dataResult
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Location data
    getAllLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ locationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all State data
    getAllStateData = () => {
        axios
            .get(ApiURL.GetAllState)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    const dataResult = respData.DataResult || [];

                    const { stateData, placeOfSupplyData } = dataResult.reduce(
                        (acc, item) => {
                            acc.stateData.push({
                                StateId: item.StateId,
                                StateCode: item.Code,
                                StateName: item.StateName
                            });
                            acc.placeOfSupplyData.push({
                                PlaceOfSupplyId: item.StateId,
                                PlaceOfSupplyCode: item.Code,
                                PlaceOfSupplyName: item.StateName
                            });
                            return acc;
                        },
                        { stateData: [], placeOfSupplyData: [] }
                    );
                    this.setState({
                        states: stateData,
                        placeOfSupplies: placeOfSupplyData
                    });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ states: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ ...this.state, tcData: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Open modal
    openModal = () => this.setState({ showModal: true })
    //Close modal
    closeModal = () => this.setState({ showModal: false })

    //Data Reload
    handleReload = () => { };

    addSpotBooking = () => {
        this.openModal();
    };

    //On change handler
    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    /* //On change handler event
    onChangeHandlerSearch = (e) => {
        if (e.target.name === 'travelCircuitId') {
            this.getAllSearchLocationData(e.target.value)
        }
        if (e.target.name === 'locationId') {
            this.getAllSearchVendorData(e.target.value, this.state.searchVendorCategoryId);
        }
        if (e.target.name === 'vendorCategoryId') {
            this.getAllSearchVendorData(this.state.searchLocationId, e.target.value);
        }
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }*/

    render() {
        var { tcData, locationData, vendorCategoryData, vendorData, travelCircuitId, locationId,
            bookingId, bookingNo, bookingDate, states, spotBookingType, vendorId, paymentDate,
            spotAmount, comment, spotBookingStatus
        } = this.state;
        return (
            <>
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Spot Payment" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-primary btn-sm px-3 mx-1" title="Add" onClick={this.addSpotBooking}>
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid py-4 mt-115">
                    <div className="card border border-primary mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Booking No.</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control-sm border border-primary w-100" name="bookingNo" value={this.state.bookingNo} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Booking Date</label>
                                        <div className="col-md-8">
                                            <input type="date" className="form-control-sm border border-primary w-100" name="bookingDate" value={this.state.bookingDate} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Travel Circuit</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control-sm border border-primary w-100" name="travelDestination" value={this.state.travelDestination} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">First Name</label>
                                        <div className="col-md-8">
                                            <input type="text" name="firstName" className="form-control-sm border border-primary w-100" value={this.state.firstName} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Last Name</label>
                                        <div className="col-md-8">
                                            <input type="text" name="lastName" className="form-control-sm border border-primary w-100" value={this.state.lastName} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Mobile No</label>
                                        <div className="col-md-8">
                                            <input type="text" name="mobile" className="form-control-sm border border-primary w-100" value={this.state.mobile} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Email</label>
                                        <div className="col-md-8">
                                            <input type="email" name="email" className="form-control-sm border border-primary w-100" value={this.state.email} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">State</label>
                                        <div className="col-md-8">
                                            <select name="stateId" className="form-control-sm border border-primary form-select w-100" value={this.state.stateId} disabled>
                                                <option value="">-- Select --</option>
                                                {states.map((item, index) => (
                                                    <option key={index} value={item.StateId}>
                                                        {`${item.StateName} [${item.StateCode}]`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Booking Status</label>
                                        <div className="col-md-8">
                                            <select name="bookingStatus" className="form-control-sm border border-primary form-select" value={this.state.bookingStatus} disabled>
                                                <option value="Active">Active</option>
                                                <option value="Postponed">Postponed</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="form-group row">
                                        <label className="col-md-2 col-form-label-sm border border-primary bg-primary-subtle">Address</label>
                                        <div className="col-md-10">
                                            <input type="text" name="address" className="form-control-sm border border-primary w-100" value={this.state.address} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Trip Category</label>
                                        <div className="col-md-8">
                                            <select name="placeOfSupplyId" className="form-control-sm border border-primary form-select w-100" value={this.state.tripCategory} disabled>
                                                <option value="Domestic">Domestic</option>
                                                <option value="International">International</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Payable Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalPayableAmount" value={this.state.totalPayableAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Paid Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalPaidAmount" value={this.state.totalPaidAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Due Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalDueAmount" value={this.state.totalDueAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TableComponent
                                columns={this.state.columns}
                                data={this.state.spotPayData}
                            />
                        </div>
                    </div>
                </div>

                {/* <!-- Spot booking modal section --> */}
                <div className={this.state.showModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage Spot Payment
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row p-3">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Travel Circuit <span className='text-danger'>*</span></label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="travelCircuitId"
                                                            value={this.state.travelCircuitId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            disabled
                                                            onChange={this.onChangeHandler}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {tcData.map((item, index) => (
                                                                <option key={index} value={item.TravelCircuitId}>
                                                                    {item.TravelCircuitName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Location <span className='text-danger'>*</span></label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="locationId"
                                                            value={locationId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandler}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {locationData.map((item, index) => (
                                                                <option key={index} value={item.LocationId}>
                                                                    {item.LocationName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor Type <span className='text-danger'>*</span></label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="spotBookingType"
                                                            value={spotBookingType}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandler}
                                                        >
                                                            <option value="">-- Select --</option>
                                                            <option value="Hotel">Hotel</option>
                                                            <option value="Car">Car</option>
                                                        </select>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor <span className='text-danger'>*</span></label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="vendorId"
                                                            value={vendorId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandler}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {vendorData.map((item, index) => (
                                                                <option key={index} value={item.VendorId}>
                                                                    {item.VendorName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Payment Date</label>
                                                    <div className="col-md-8">
                                                        <input type="date" className="form-control-sm border border-primary w-100" name="bookingDate" value={paymentDate} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Spot Amount</label>
                                                    <div className="col-md-8">
                                                        <input type="number" name="spotAmount" className="form-control-sm border border-primary w-100" value={spotAmount} onChange={this.onChangeHandler} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 px-0 pr-2">
                                                <textarea
                                                    name="comment"
                                                    value={comment}
                                                    placeholder='Put your comment...'
                                                    className="form-control border border-secondary"
                                                    rows="2"
                                                    onChange={this.onChangeHandler}>
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mt-2">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Payment Status</label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="spotBookingStatus"
                                                            value={spotBookingStatus}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandler}
                                                        >
                                                            <option value="Collected">Collected</option>
                                                            <option value="Pending">Pending</option>
                                                        </select>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" >
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--  Spot booking modal section --> */}


            </>
        );
    }
}

export default SpotBooking;